import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Button, Card, Spin } from 'antd';

import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import PublicLayout from 'v2/components/Shared/PublicLayout';
import BankAccountService from 'v2/services/bankAccount';

const ConfirmBankAccount = () => {
  const { uuid } = useParams<{ uuid?: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [account, setAccount] = useState(null);
  const [hasSent, setHasSent] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [expiredToken, setExpiredToken] = useState<boolean>(false);
  const [successConfirmation, setSuccessConfirmation] = useState<boolean>(false);

  const qs = new URLSearchParams(useLocation().search);
  const token = qs.get('token');

  useEffect(() => {
    if (!uuid || !token) return;

    BankAccountService.getBankAccountByUuid(uuid, token)
      .then(account => {
        setAccount(account);
        setIsLoading(false);
      })
      .catch(() => {
        setHasSent(false);
        setIsLoading(false);
        setExpiredToken(true);
      });
  }, [token, uuid]);

  const confirmBankAccount = useCallback(() => {
    setIsSending(true);
    BankAccountService.confirmBankAccount(uuid, token)
      .then(() => {
        setHasSent(true);
        setIsSending(false);
        setSuccessConfirmation(true);
      })
      .catch(() => {
        setHasSent(false);
        setIsSending(false);
        setExpiredToken(true);
      });
  }, [token, uuid, setIsSending]);

  if (isLoading) return <GlobalLoading />;
  if (expiredToken) return <TokenExpired />;
  if (successConfirmation) return <SuccessConfirmation />;

  return (
    <PublicLayout>
      <Card>
        <p className='text-center text-base font-medium'>Por favor, confirme seus dados bancários:</p>

        <div className='mt-4 flex items-center justify-center'>
          <div className='text-left'>
            <p className='m-0!'>
              <b>Banco:</b> {account?.bank_id}
            </p>
            <p className='m-0!'>
              <b>Agência:</b> {account?.agency} - {account?.agency_digit}
            </p>
            <p className='m-0!'>
              <b>Conta: </b> {account?.account} - {account?.account_digit}
            </p>
            <p className='m-0!'>
              <b>Moeda:</b> {account?.currency?.code}
            </p>
          </div>
        </div>

        <div className='mt-4 text-center'>
          {hasSent ? (
            <p>Dados bancários confirmados!</p>
          ) : (
            <Button disabled={isSending} type='primary' onClick={confirmBankAccount}>
              {isSending && <Spin size='small' />} <span className='ml-2'>Confirmar Dados Bancários</span>
            </Button>
          )}
        </div>
      </Card>
    </PublicLayout>
  );
};

const TokenExpired = () => {
  return (
    <PublicLayout>
      <Card>
        <div className='text-center'>
          <p className='text-base font-medium'>Esse link está expirado ou inválido!</p>
          <p>
            Para solicitar um novo link de confirmação de dados bancários, acesse suas contas bancárias pelo botão
            abaixo:
          </p>
        </div>

        <div className='mt-4 text-center'>
          <a href={'/producer/profile/bankdata'}>
            <Button type='primary'>Acessar Minhas Contas Bancárias</Button>
          </a>
        </div>
      </Card>
    </PublicLayout>
  );
};

const SuccessConfirmation = () => {
  return (
    <PublicLayout>
      <Card>
        <div className='text-center'>
          <p className='text-base font-medium'>Dados bancários confirmados com sucesso!</p>
          <p>
            Agora é com a gente, nosso time financeiro fará a verificação dos dados. Esse processo costuma ser rápido
            (de 1 a 5 dias úteis). Fique tranquilo, vamos nos esforçar para ser no menor tempo possível.
          </p>
        </div>
      </Card>
    </PublicLayout>
  );
};

export default ConfirmBankAccount;
